import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const ScanCasePackSchema = z.object({
  productId: productIdFormat.schema,
  barcode: z.string(),
  units: z.number(),
});

export type ScanCasePack = z.infer<typeof ScanCasePackSchema>;
